import { render } from "./WidgetCreator.vue?vue&type=template&id=4e58eb1d&scoped=true&ts=true"
import script from "./WidgetCreator.vue?vue&type=script&lang=ts"
export * from "./WidgetCreator.vue?vue&type=script&lang=ts"

import "./WidgetCreator.vue?vue&type=style&index=0&id=4e58eb1d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e58eb1d"]])

export default __exports__